/* eslint-disable @typescript-eslint/no-magic-numbers */

// Breakpoints
export const BREAK_POINTS = {
  XS: 375,
  SM: 576,
  MD: 768,
  LG: 1024,
  XL: 1366,
  XXL: 1920,
};

export const ANIMATION_DURATION = 100;

export const SECONDS_IN_A_YEAR = 60 * 60 * 24 * 365;

// Verwijzen
export const PAGE_LOCKED_CLASS = 'page--locked';
